// src/components/Footer.jsx
// Page footer: copyright and a line about security (3.19.9: the version and
// What's new moved out; they're on the portal title and in the user menu).
import { CURRENT_VERSION } from './WhatsNew';
import Emo from './Emo';

export const COMPANY_NAME = 'Crazy Pixels Technologies';

// showVersion (3.20.0): the sign-in page also shows the portal version
export default function Footer({ showVersion = false }) {
  const year = new Date().getFullYear();
  return (
    <footer style={S.footer}>
      <span>© {year} {COMPANY_NAME}. All rights reserved.{showVersion && <> · Fax Portal v{CURRENT_VERSION}</>}</span>
      <span style={S.secure}><Emo e="🔒" /> Your faxes are protected with encryption and secure access.</span>
    </footer>
  );
}

const S = {
  footer: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    gap: 4, padding: '18px 16px 22px', fontSize: 12, color: 'var(--t-607d8b)', textAlign: 'center'
  },
  secure: { color: 'var(--t-78909c)' },
};
